import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("reliable-multi-section", {
    model: {
      defaults: {
        draggable: true,
        droppable: false,
        components: html`
          <section class="container mx-auto md:py-16 py-10 px-4 md:px-12">
            <div
              data-aos="fade-up"
              class=" md:grid-cols-2 gap-x-20 gap-y-6  grid  w-full "
            >
              <div class="flex items-center justify-start">
                <img src="./image1.svg" class="w-full h-full" />
              </div>
              <div class="">
                <div class="flex gap-2 items-center">
                  <div class="bg-amber-600 w-1 md:h-12 h-6 inline-block"></div>
                  <h3
                    class="text-xl md:text-4xl text-[#0083D7] font-bold font-roboto p-1 tracking-normal whitespace-nowrap"
                  >
                    About US
                  </h3>
                </div>
                <div class="w-full leading-9 tracking-wide mt-4">
                  <h1
                    class="font-roboto text-xl md:text-3xl font-semibold tracking-normal   w-full text-[#0083D7] "
                  >
                    A company specializing in delivery and transportation
                  </h1>
                  <p
                    class="text-lg leading-7 md:text-xl font-roboto tracking-normal mt-3 text-bla"
                  >
                    We ensure reliable, timely delivery with a global network,
                    offering customized solutions for seamless cargo transport
                    worldwide.
                  </p>
                </div>
                <div class="flex items-center justify-start gap-8 mt-5">
                  <div class="flex items-center gap-2">
                    <h3
                      class="font-roboto text-lg md:text-2xl font-semibold text-[#FA6914] tracking-normal"
                    >
                      2K
                    </h3>
                    <div class="bg-black w-0.5 md:h-9 h-5 inline-block"></div>
                    <h3
                      class="font-roboto text-lg md:text-xl font-semibold tracking-normal text-[#0083D7]"
                    >
                      Project Done
                    </h3>
                  </div>
                  <div class="flex items-center gap-2">
                    <h3
                      class="font-roboto text-lg md:text-2xl font-semibold tracking-normal text-[#FA6914]"
                    >
                      1K
                    </h3>
                    <div class="bg-black w-0.5 md:h-9 h-5 inline-block"></div>
                    <h3
                      class="font-roboto text-lg md:text-xl font-semibold tracking-normal text-[#0083D7]"
                    >
                      Clients
                    </h3>
                  </div>
                </div>
                <div class="flex items-center gap-8 mt-4">
                  <p
                    class="font-roboto text-normal font-semibold  tracking-normal md:text-xl text-sm"
                  >
                    For inquiries or assistance, email us at:
                  </p>
                </div>
                <div
                  class="flex items-center gap-2 text-[#0083D7] tracking-normal leading-2 md:text-lg text-sm"
                >
                  <svg
                    width="24"
                    height="19"
                    viewBox="0 0 24 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.35013 18.7068C1.71781 18.7068 1.1767 18.4819 0.726791 18.032C0.276884 17.5821 0.0515477 17.0406 0.0507812 16.4075V2.61136C0.0507812 1.97904 0.276118 1.43793 0.726791 0.988021C1.17746 0.538115 1.71858 0.312778 2.35013 0.312012H20.745C21.3773 0.312012 21.9188 0.537348 22.3694 0.988021C22.8201 1.43869 23.0451 1.97981 23.0443 2.61136V16.4075C23.0443 17.0398 22.8193 17.5813 22.3694 18.032C21.9195 18.4826 21.378 18.7076 20.745 18.7068H2.35013ZM11.5475 10.4579C11.6433 10.4579 11.7441 10.4433 11.8499 10.4142C11.9557 10.3851 12.0561 10.3422 12.1511 10.2855L20.2851 5.19814C20.4384 5.10233 20.5533 4.98276 20.63 4.83944C20.7066 4.69611 20.745 4.53784 20.745 4.36462C20.745 3.9814 20.5821 3.69398 20.2563 3.50236C19.9306 3.31075 19.5953 3.32033 19.2504 3.53111L11.5475 8.35975L3.84471 3.53111C3.49981 3.32033 3.16449 3.31573 2.83875 3.51731C2.513 3.71889 2.35013 4.00132 2.35013 4.36462C2.35013 4.55623 2.38846 4.72409 2.4651 4.86818C2.54175 5.01227 2.65671 5.12226 2.81 5.19814L10.944 10.2855C11.0398 10.3429 11.1406 10.3862 11.2463 10.4154C11.3521 10.4445 11.4525 10.4587 11.5475 10.4579Z"
                      fill="#FA6914"
                    />
                  </svg>
                  <p>support@reliablecargo.com.np</p>
                </div>
              </div>
            </div>
          </section>
        `,
        script: function () {
          const initLib = function () {
            //@ts-ignore
            AOS.init();
          };
          //@ts-ignore
          if (typeof AOS === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src = "https://unpkg.com/aos@2.3.1/dist/aos.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
